import axios from 'axios'
import { handleErrors } from '../utils/errorHandler'

// Same deployed logging gateway as RequestService.createLog (not VITE_FUNCTIONS_BASE_URL,
// which points at the emulator in local dev and cannot write to Cloud Logging).
const LOGS_URL = (import.meta.env.VITE_CREATE_LOG_URL || '').replace(/\/$/, '')
const AUTH_FAILURE_URL = LOGS_URL ? `${LOGS_URL}/auth-failure` : ''

const jsonHeaders = {
  'Content-Type': 'application/json',
  Accept: 'application/json'
}

/**
 * Fire-and-forget audit log for successful login.
 * @param {string} token - Firebase ID token
 */
export function logLoginSuccess(token) {
  if (!LOGS_URL || !token) return
  axios.post(
    LOGS_URL,
    { logName: 'audit_log', eventType: 'login_success' },
    { headers: { ...jsonHeaders, Authorization: `Bearer ${token}` } }
  ).catch(err => handleErrors('auditLog:login_success', err))
}

/**
 * Fire-and-forget audit log for token refresh.
 * @param {string} token - Refreshed Firebase ID token
 */
export function logTokenRefresh(token) {
  if (!LOGS_URL || !token) return
  axios.post(
    LOGS_URL,
    { logName: 'audit_log', eventType: 'token_refresh' },
    { headers: { ...jsonHeaders, Authorization: `Bearer ${token}` } }
  ).catch(err => handleErrors('auditLog:token_refresh', err))
}

/**
 * Fire-and-forget audit log for failed login (no auth).
 * @param {string} email - Attempted username/email
 */
export function logLoginFailed(email) {
  if (!AUTH_FAILURE_URL) return
  axios.post(AUTH_FAILURE_URL, { email }, { headers: jsonHeaders })
    .catch(err => handleErrors('auditLog:login_failed', err))
}
